(() => {
  const SELECTOR = "[data-custom-subs]";
  let hasGlobalVariantSubscription = false;

  function formatMoneyCents(cents, format) {
    if (cents == null) return "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || window.cartStrings?.moneyFormat || "{{amount}}";
    const match = formatString.match(placeholderRegex);
    if (!match) return String(cents);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";
      if (isNaN(number) || number === null) return "0";
      number = (number / 100.0).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }

    let value = "";
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function stripTrailingZeroDecimals(moneyText) {
    if (!moneyText) return moneyText;
    return String(moneyText).replace(/([,.])00(?=\s|$)/, "");
  }

  function getSelectedVariantJson(root) {
    const variantSelects = root.closest(".main-product-section")?.querySelector("variant-selects");
    if (!variantSelects) return null;
    try {
      const raw = variantSelects.querySelector("[data-selected-variant]")?.textContent;
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  function getSellingPlanNameMap(root) {
    try {
      const raw = root.querySelector("[data-custom-subs-plans]")?.textContent;
      const arr = raw ? JSON.parse(raw) : [];
      return Object.fromEntries(arr.map((p) => [String(p.id), p.name]));
    } catch {
      return {};
    }
  }

  function extractWeeksFromPlanName(name) {
    if (!name) return "";
    const match = String(name).match(/every\s+(\d+)\s*(?:week|woche)/i);
    if (!match) return "";
    return String(match[1]).padStart(2, "0");
  }

  function formatDeliveryEveryLabel(root, weeksPadded) {
    const template =
      root.dataset.customSubsDeliveryTemplate ||
      root.querySelector("[data-custom-subs-dropdown-trigger-label]")?.dataset.customSubsDeliveryTemplate ||
      "";
    if (template && weeksPadded) return template.replace("[weeks]", weeksPadded);
    return weeksPadded;
  }

  function getDeliveryLabelFromPlanName(root, planName) {
    const weeks = extractWeeksFromPlanName(planName);
    return formatDeliveryEveryLabel(root, weeks) || String(planName || "");
  }

  function getAllProductForms(root) {
    return (
      root.closest(".main-product-section")?.querySelectorAll(".product-form form") ||
      root.closest(".collection-slider-product-info")?.querySelectorAll(".product-form form") ||
      []
    );
  }

  function ensureSellingPlanInput(form, sellingPlanId) {
    if (!form) return;
    let input = form.querySelector('input[name="selling_plan"]');

    if (!sellingPlanId) {
      // Don't remove the input; removal doesn't fire change events.
      // Instead, disable + clear it and dispatch change so existing theme listeners update prices.
      if (input) {
        input.value = "";
        input.disabled = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
      return;
    }

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "selling_plan";
      form.appendChild(input);
    }

    input.disabled = false;
    if (input.value !== String(sellingPlanId)) input.value = String(sellingPlanId);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function ensureSellingPlanInputs(root, sellingPlanId) {
    getAllProductForms(root).forEach((form) => ensureSellingPlanInput(form, sellingPlanId));
  }


  function setSelectedOption(root, option) {
    root.querySelectorAll(".custom-subs__row").forEach((row) => row.classList.remove("is-selected"));
    const row = root.querySelector(`.custom-subs__row[data-custom-subs-option="${option}"]`);
    if (row) row.classList.add("is-selected");

    // Dropdown should only be visible when subscription is selected.
    setDropdownVisible(root, option === "subscription");
  }

  function setDropdownVisible(root, visible) {
    const dropdown = root.querySelector("[data-custom-subs-dropdown]");
    if (!dropdown) return;
    dropdown.toggleAttribute("hidden", !visible);
  }

  function updateSubPriceUI(root, oneTimeCents, subCents) {
    const moneyFormat = window.cartStrings?.moneyFormat;
    const priceEl = root.querySelector("[data-custom-subs-sub-price]");
    const compareEl = root.querySelector("[data-custom-subs-compare]");

    if (priceEl) priceEl.textContent = stripTrailingZeroDecimals(formatMoneyCents(subCents, moneyFormat));
    if (compareEl) compareEl.textContent = stripTrailingZeroDecimals(formatMoneyCents(oneTimeCents, moneyFormat));
  }

  function updateOneTimePriceUI(root, oneTimeCents) {
    const moneyFormat = window.cartStrings?.moneyFormat;
    const el = root.querySelector("[data-custom-subs-one-time-price]");
    if (!el) return;
    el.textContent = stripTrailingZeroDecimals(formatMoneyCents(oneTimeCents, moneyFormat));
  }

  function updateDiscountLabel(root, oneTimeCents, subCents) {
    const el = root.querySelector("[data-custom-subs-subscribe-label]");
    if (!el) return;
    const discount = oneTimeCents > 0 ? Math.round(((oneTimeCents - subCents) * 100) / oneTimeCents) : 0;
    const discountText = `${Math.max(0, discount)}%`;
    const template = el.dataset.customSubsSubscribeTemplate || "";
    if (template) {
      el.textContent = template.replace("[discount]", discountText);
    } else {
      el.textContent = discountText;
    }
  }

  function setDropdownOpen(root, open) {
    const dropdown = root.querySelector("[data-custom-subs-dropdown]");
    const trigger = root.querySelector("[data-custom-subs-dropdown-trigger]");
    const menu = root.querySelector("[data-custom-subs-dropdown-menu]");
    if (!dropdown || !trigger || !menu) return;

    dropdown.classList.toggle("is-open", open);
    trigger.setAttribute("aria-expanded", open ? "true" : "false");
    menu.toggleAttribute("hidden", !open);
  }

  function setDropdownTriggerText(root, deliveryLabel) {
    const label = root.querySelector("[data-custom-subs-dropdown-trigger-label]");
    if (!label) return;
    label.textContent = deliveryLabel;
  }

  function selectSellingPlan(root, sellingPlanId, subCents, deliveryLabel) {
    const variant = getSelectedVariantJson(root);
    const oneTimeCents = variant?.price ?? Number(root.dataset.oneTimeCents || 0);

    ensureSellingPlanInputs(root, sellingPlanId);
    updateSubPriceUI(root, oneTimeCents, subCents);
    updateDiscountLabel(root, oneTimeCents, subCents);
    setDropdownTriggerText(root, deliveryLabel);
  }

  function hydrateFromVariant(root, variant) {
    const oneTimeCents = variant?.price ?? Number(root.dataset.oneTimeCents || 0);
    const allocations = variant?.selling_plan_allocations || [];
    const planNameMap = getSellingPlanNameMap(root);

    updateOneTimePriceUI(root, oneTimeCents);

    const subRow = root.querySelector('.custom-subs__row[data-custom-subs-option="subscription"]');
    const hasSubs = allocations.length > 0;
    root.toggleAttribute("hidden", !hasSubs);
    if (subRow) subRow.toggleAttribute("hidden", !hasSubs);
    setDropdownVisible(root, false);
    setDropdownOpen(root, false);

    const menu = root.querySelector("[data-custom-subs-dropdown-menu]");
    if (menu) menu.innerHTML = "";

    if (!hasSubs) {
      setSelectedOption(root, "one-time");
      ensureSellingPlanInputs(root, null);
      return;
    }

    // Build dropdown items
    allocations.forEach((alloc, idx) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.setAttribute("role", "option");
      btn.className = "custom-subs__dropdown-item" + (idx === 0 ? " is-selected" : "");
      btn.setAttribute("aria-selected", idx === 0 ? "true" : "false");
      btn.dataset.customSubsSellingPlanId = String(alloc.selling_plan_id);
      btn.dataset.customSubsSubPriceCents = String(alloc.price);

      const planId = String(alloc.selling_plan_id);
      const planName = planNameMap[planId];
      const weeksPadded = extractWeeksFromPlanName(planName);
      const deliveryLabel = getDeliveryLabelFromPlanName(root, planName);
      btn.dataset.customSubsWeeks = weeksPadded;
      btn.dataset.customSubsDeliveryLabel = deliveryLabel;

      btn.innerHTML = `<span class="custom-subs__radio" aria-hidden="true"></span><span class="custom-subs__dropdown-item-label"></span>`;
      btn.querySelector(".custom-subs__dropdown-item-label").textContent = deliveryLabel;
      menu?.appendChild(btn);
    });

    // Default: subscription preselected, first plan
    const defaultSellingPlanId = String(allocations[0].selling_plan_id);
    setSelectedOption(root, "subscription");
    setDropdownVisible(root, true);

    const firstPlanName = planNameMap[String(allocations[0].selling_plan_id)];
    const firstDeliveryLabel = getDeliveryLabelFromPlanName(root, firstPlanName);
    selectSellingPlan(root, defaultSellingPlanId, allocations[0].price, firstDeliveryLabel);
  }

  function initOne(root) {
    if (root.__customSubsInit) return;
    root.__customSubsInit = true;

    const oneTimeRow = root.querySelector('.custom-subs__row[data-custom-subs-option="one-time"]');
    const subRow = root.querySelector('.custom-subs__row[data-custom-subs-option="subscription"]');
    const dropdownTrigger = root.querySelector("[data-custom-subs-dropdown-trigger]");
    const dropdownMenu = root.querySelector("[data-custom-subs-dropdown-menu]");

    function onVariantMaybeChanged() {
      const variant = getSelectedVariantJson(root);
      hydrateFromVariant(root, variant);
    }

    // Initial hydrate (and again shortly after for late updates)
    onVariantMaybeChanged();
    setTimeout(onVariantMaybeChanged, 250);

    oneTimeRow?.addEventListener("click", () => {
      setSelectedOption(root, "one-time");
      setDropdownOpen(root, false);
      ensureSellingPlanInputs(root, null);
    });

    subRow?.addEventListener("click", () => {
      setSelectedOption(root, "subscription");
      const btn =
        root.querySelector(".custom-subs__dropdown-item.is-selected") ||
        root.querySelector(".custom-subs__dropdown-item");
      if (!btn) return;
      selectSellingPlan(
        root,
        btn.dataset.customSubsSellingPlanId,
        Number(btn.dataset.customSubsSubPriceCents || 0),
        btn.dataset.customSubsDeliveryLabel || "",
      );
    });

    dropdownTrigger?.addEventListener("click", () => {
      const isOpen = dropdownTrigger.getAttribute("aria-expanded") === "true";
      setDropdownOpen(root, !isOpen);
    });

    dropdownMenu?.addEventListener("click", (e) => {
      const btn = e.target.closest(".custom-subs__dropdown-item");
      if (!btn) return;

      root.querySelectorAll(".custom-subs__dropdown-item").forEach((b) => {
        b.classList.remove("is-selected");
        b.setAttribute("aria-selected", "false");
      });
      btn.classList.add("is-selected");
      btn.setAttribute("aria-selected", "true");

      setSelectedOption(root, "subscription");
      selectSellingPlan(
        root,
        btn.dataset.customSubsSellingPlanId,
        Number(btn.dataset.customSubsSubPriceCents || 0),
        btn.dataset.customSubsDeliveryLabel || "",
      );
      setDropdownOpen(root, false);
    });

    document.addEventListener("product-info:loaded", onVariantMaybeChanged);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initOne);

    // Re-hydrate on variant changes (Shopify/Dawn pubsub).
    if (!hasGlobalVariantSubscription && typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      hasGlobalVariantSubscription = true;
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant } }) => {
        if (!sectionId) return;
        document
          .querySelectorAll(`${SELECTOR}[data-section-id="${sectionId}"]`)
          .forEach((root) => hydrateFromVariant(root, variant));
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();

